module.exports = __webpack_public_path__ + "img/top_icon_1.48323395.png";